"use client"

import { useState, useEffect } from "react"
import { X } from 'lucide-react'
import { motion, AnimatePresence } from "framer-motion"
import Cookies from 'js-cookie'
export function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = Cookies.get("cookieConsent")
    if (!cookieConsent) {
      setShowBanner(true)
    }
  }, [])

  const acceptCookies = () => {
    Cookies.set("cookieConsent", "accepted", { expires: 365 }) // cookie válida por 365 días
    setShowBanner(false)
  }

  const declineCookies = () => {
    Cookies.set("cookieConsent", "declined", { expires: 365 })
    setShowBanner(false)
  }

  const closeBanner = () => {
    Cookies.set("cookieConsent", "closed", { expires: 365 })
    setShowBanner(false)
  }


  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div 
          className="fixed bottom-0 left-0 right-0 z-50 bg-white dark:bg-[var(--navy-blue-light)] border-t shadow-lg p-4 md:px-6"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
        >
          <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex-1 text-center sm:text-left">
              <p className="text-sm md:text-base text-gray-700 dark:text-gray-300">
                Este sitio utiliza cookies para mejorar su experiencia. Al continuar navegando, aceptas nuestra política de cookies.
              </p>
            </div>
            <div className="flex items-center gap-2 md:gap-3">
              <motion.button
                className="px-3 py-1.5 text-sm border text-white border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                onClick={declineCookies}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Rechazar
              </motion.button>
              <motion.button
                className="px-3 py-1.5 text-sm bg-[var(--gold)] text-white rounded-md hover:bg-[var(--gold-dark)] transition-colors"
                onClick={acceptCookies}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Aceptar
              </motion.button>
              <motion.button 
                className="h-8 w-8 flex items-center justify-center rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                onClick={closeBanner}
                aria-label="Cerrar banner de cookies"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <X className="h-4 w-4" />
              </motion.button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
